import React from 'react';

// MobileApp Component
export default function MobileApp() {
  return (
    <div className="bg-gray-100 min-h-screen flex flex-col">
      
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-indigo-400 to-blue-500 flex flex-col items-center justify-center py-20">
        <div className="text-center p-5">
          <h1 className="text-5xl font-extrabold text-white mb-4 text-shadow-lg">
            Welcome to Android App Services
          </h1>
          <p className="text-lg text-gray-100 mb-8 max-w-lg">
            We are a professional design agency focusing on building functional, simple, and human-centered digital products for the future.
          </p>
          <button className="bg-white text-blue-500 font-bold px-8 py-4 rounded-full shadow-lg hover:bg-gray-200 transform hover:scale-110 transition-all duration-300">
            Learn More
          </button>
        </div>
      </section>

      
      {/* Services Section */}
      <section className="py-16 px-4">
        <h2 className="text-3xl font-bold text-center mb-8 text-gray-800">
          Our Services
        </h2>
        <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Example Service Card */}
          {Array.from({ length: 6 }, (_, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-xl font-semibold mb-2">Service {index + 1}</h3>
              <p className="text-gray-600 mb-4">
                A brief description of what this service entails and how it can benefit you.
              </p>
              <button className="bg-blue-500 text-white px-4 py-2 rounded-full hover:bg-blue-600">
                Learn More
              </button>
            </div>
          ))}
        </div>
      </section>

      
      {/* Testimonials Section */}
      <section className="bg-gray-200 py-16 px-4">
        <h2 className="text-3xl font-bold text-center mb-8 text-gray-800">
          What Our Clients Say
        </h2>
        <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Example Testimonial Card */}
          {Array.from({ length: 3 }, (_, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg p-6">
              <p className="text-gray-600 mb-4">
                "This agency transformed our app into something truly special. Their attention to detail and user-centered design approach made all the difference."
              </p>
              <h4 className="font-semibold">Client {index + 1}</h4>
            </div>
          ))}
        </div>
      </section>

      
      {/* Call to Action Section */}
      <section className="py-16 px-4 bg-blue-500 text-white text-center">
        <h2 className="text-3xl font-bold mb-4">Ready to Start Your Project?</h2>
        <p className="mb-8">
          Get in touch with us today to discuss your app needs.
        </p>
        <button className="bg-white text-blue-500 font-bold px-8 py-4 rounded-full shadow-lg hover:bg-gray-200 transform hover:scale-110 transition-all duration-300">
          Contact Us
        </button>
      </section>

    </div>
  );
}